import { useState, useEffect } from "react";

function Timer({ timerReset, setTimerReset, tacAgain, setTacAgain, setGetTAC, tacStatus, forceTimerGone }) {
    const [minutes, setMinutes] = useState(4);
    const [seconds, setSeconds] = useState(59);

    // timer tac
    useEffect(() => {
        if (timerReset === true) {
            setMinutes(4);
            setSeconds(59);
        }
        setTimerReset(false);

        const interval = setInterval(() => {
            if (seconds > 0) setSeconds(seconds - 1);
            if (seconds === 0) {
                if (seconds === 0 && minutes === 0) {
                    clearInterval(interval);
                    setTacAgain(false);
                    setGetTAC(0);
                }
                else if (seconds === 0 && minutes > 0) {
                    setSeconds(59);
                    setMinutes(minutes - 1);
                }
            }
        }, 1000);

        return () => { clearInterval(interval) };
    }, [seconds, tacStatus, tacAgain]);

    return (
        <div className="countdown-text">
            {((tacStatus && (seconds > 0 || minutes > 0)) && (!forceTimerGone)) &&
                <>
                    Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                    {seconds < 10 ? `0${seconds}` : seconds}
                </>
            }
        </div>
    );
}

export default Timer;
